export class TipoBico {
    Id: number = 0;
    Descricao:string = "";
}
